(() => {
  const panel=document.querySelector('[data-availability-panel]');
  if(!panel)return;
  const format=new Intl.NumberFormat('es-CL');
  const status=panel.querySelector('[data-stock-status]');
  const keys=['chile','importation'];
  const numbers=keys.map(key=>panel.querySelector(`[data-stock-count="${key}"]`));
  const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
  let pending=false,lastSuccess=0,targets=null,visible=false,frame=0,animated=false;
  function paint(progress){
    const eased=1-Math.pow(1-progress,3);
    numbers.forEach((number,index)=>{number.textContent=format.format(Math.round(targets[index]*eased));});
  }
  function animate(){
    if(!targets||!visible||document.hidden||animated)return;
    cancelAnimationFrame(frame);animated=true;
    if(reducedMotion.matches){paint(1);return;}
    const started=performance.now();paint(0);
    function tick(now){
      const progress=Math.min(1,(now-started)/1400);
      paint(progress);
      if(progress<1)frame=requestAnimationFrame(tick);
    }
    frame=requestAnimationFrame(tick);
  }
  async function refresh(){
    if(pending||document.hidden||Date.now()-lastSuccess<60000){animate();return;}
    pending=true;panel.setAttribute('aria-busy','true');
    try{
      const response=await fetch('https://portal.klever-shop.cl/api/public/availability-summary',{cache:'no-store',signal:AbortSignal.timeout(10000)});
      if(!response.ok)throw Error('Unavailable');
      const data=await response.json();
      const counts=keys.map(key=>data[key]?.references);
      if(counts.some(count=>!Number.isSafeInteger(count)||count<0)||counts[0]+counts[1]!==data.publishedReferences)throw Error('Invalid count');
      cancelAnimationFrame(frame);targets=counts;animated=false;
      panel.classList.remove('is-unavailable');lastSuccess=Date.now();animate();
      status.textContent=`${format.format(counts[0])} productos publicados con stock confirmado en Chile. ${format.format(counts[1])} productos publicados por importación. ${format.format(data.publishedReferences)} productos publicados en total.`;
    }catch{
      cancelAnimationFrame(frame);targets=null;animated=false;
      panel.classList.add('is-unavailable');numbers.forEach(number=>{number.textContent='—';});
      status.textContent='No se pudo actualizar la disponibilidad. Revisa los productos o solicita una cotización.';
    }finally{pending=false;panel.setAttribute('aria-busy','false');}
  }
  if('IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>{
      const inView=entries.some(entry=>entry.isIntersecting&&entry.intersectionRatio>=0.1);
      if(inView===visible)return;
      visible=inView;
      if(visible)void refresh();
      else{cancelAnimationFrame(frame);animated=false;}
    },{threshold:0.1});observer.observe(panel);
  }else{visible=true;void refresh();}
  document.addEventListener('visibilitychange',()=>{
    if(document.hidden){cancelAnimationFrame(frame);animated=false;}
    else void refresh();
  });
  window.addEventListener('pageshow',()=>void refresh());
  reducedMotion.addEventListener('change',()=>{if(reducedMotion.matches&&targets){cancelAnimationFrame(frame);paint(1);}});
})();
